import declare from "dojo/_base/declare";

const ActualMixin = declare(null, {
	_getDimensionActualsKey(/*Context*/ctx, /*Node*/scd) {
		// summary: return SysID + referenced library item
		return scd.Actual + "_" + scd.SysID;
	},

	_getDimensionActualsKeyPre47(/*Context*/ctx, /*Node*/scd) {
		// summary: return name + size chart URL
		const scr = ctx.cache.getNode(scd.__Parent__);
		const ad = ctx.cache.getNode(scd.Actual);
		return ad ? (ad.$Name + "_" + scr.__Parent__) : null;
	},

	_getDimensionActualsKeySuffix(/*Context*/ctx, /*Node*/scd) {
		// summary: return SampleActuals key suffix
		return "_" + scd.SysID;
	},

	/**
 	* Return SysID + referenced original library item
	* @param {Context} ctx
	* @param {Node} scd
	*/
	_getDimensionOriginalKey: function(ctx, scd) {
		return scd.Original + "_" + scd.SysID;
	},
	
});

export = ActualMixin;